import type {BioIconProps} from './common-types'

export function ReviewsIcon({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10.5C2 6.5334 5.69006 3.5 10 3.5C14.3099 3.5 18 6.5334 18 10.5C18 14.4666 14.3099 17.5 10 17.5C9.48658 17.5 8.98381 17.4577 8.49617 17.3766C7.51177 18.0834 6.3037 18.5 5 18.5C4.85237 18.5 4.70585 18.4947 4.56065 18.4841C4.29888 18.4651 4.06608 18.3107 3.9468 18.0769C3.82753 17.8431 3.83914 17.564 3.97742 17.3409C4.29476 16.829 4.48371 16.2294 4.49899 15.5848C2.97849 14.3253 2 12.5244 2 10.5Z"
        fill="#A1A1AA"
      />
    </svg>
  )
}
